import { render, staticRenderFns } from "./master-child-edit.vue?vue&type=template&id=5018b7b0"
import script from "./master-child-edit.vue?vue&type=script&lang=js"
export * from "./master-child-edit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/Paldia/Paldia FE/FE-Paldia-Dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5018b7b0')) {
      api.createRecord('5018b7b0', component.options)
    } else {
      api.reload('5018b7b0', component.options)
    }
    module.hot.accept("./master-child-edit.vue?vue&type=template&id=5018b7b0", function () {
      api.rerender('5018b7b0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Masters/master-child-edit.vue"
export default component.exports